export default __webpack_public_path__ + "static/media/Swenson-He-logo.9940fba5.jpeg";